/**
 * DOM manipulation utility functions
 */
export default {
  /**
   * Removes a specific attribute from all elements that match the given selector
   * @param {string} selector - CSS selector to find elements
   * @param {string} attribute - Attribute name to remove (defaults to 'aria-selected')
   */
  removeAttributeFromElements: (selector, attribute = 'aria-selected') => {
    const elements = document.body.querySelectorAll(selector);
    elements.forEach((element) => {
      element.removeAttribute(attribute);
    });
  },
};
